var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "notification" }, [
    _c("div", { staticClass: "media" }, [
      _c("div", { staticClass: "media-object" }, [
        _c("img", { attrs: { src: _vm.notification.icon } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "media-body" }, [
        _c(
          "a",
          {
            staticClass: "notification-mark-read",
            attrs: { href: "#", title: "Mark as read" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.markAsRead.apply(null, arguments)
              }
            }
          },
          [
            _c("i", {
              staticClass: "icon-close",
              attrs: { "aria-hidden": "true" }
            })
          ]
        ),
        _vm._v(" "),
        _c("strong", { staticClass: "notification-title" }, [
          _c("a", { attrs: { href: _vm.notification.action_url } }, [
            _vm._v(_vm._s(_vm.notification.title))
          ])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "notification-desc" }, [
          _vm._v("\n        " + _vm._s(_vm.notification.body) + "\n      ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "notification-meta" }, [
          _c(
            "small",
            { staticClass: "timestamp" },
            [
              _c("timeago", {
                attrs: { since: _vm.notification.created, "auto-update": 30 }
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a4ce154", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a4ce154","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Notification.vue
// module id = 346
// module chunks = 1 2